import { useMemo } from 'react';
import { buildDeeplinkKey, hasAnyDeeplinkParam } from '../routeUtils';

const useRouteQueryParams = (search) => {
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(search);

    return {
      action: params.get('action') || '',
      code: params.get('code') || '',
      authority: params.get('authority') || '',
      country: params.get('country') || '',
      lang: params.get('lang') || params.get('language') || '',
      applicationsLicensePlate: params.get('applications_license_plate') || '',
      applicationsCode: params.get('applications_code') || '',
    };
  }, [search]);

  const hasDeeplinkParams = useMemo(
    () => hasAnyDeeplinkParam(queryParams),
    [queryParams]
  );

  const deeplinkKey = useMemo(
    () => buildDeeplinkKey(queryParams),
    [queryParams]
  );

  return {
    deeplinkKey,
    hasDeeplinkParams,
    queryParams,
  };
};

export default useRouteQueryParams;
